import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Underline = (props) => (
  <Icon viewBox="0 0 30 30" {...props}>
    <g>
      <path d="M10 23h11v-2H10v2zm5.5-3.8c2.6 0 4.5-2.1 4.5-4.8V9c0-.6-.4-1-1-1s-1 .4-1 1v5.4c0 1.4-.9 2.8-2.5 2.8S13 15.8 13 14.4V9c0-.6-.4-1-1-1s-1 .4-1 1v5.4c0 2.8 1.9 4.8 4.5 4.8z"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default Underline;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Underline.js